var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "icon-video_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-video_svg__cls-1{fill:#787878}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "icon-video_svg__cls-1",
  d: "M22 9.42H8.66L22 6.35l-.68-2.94a1.53 1.53 0 00-1.82-1.15L3.19 6A1.51 1.51 0 002 7.48v12.76a1.53 1.53 0 001.53 1.54h16.9A1.55 1.55 0 0022 20.24zm-4.29-5.57l2.63 1.72-2 .47-2.66-1.72zm-4.09.95l2.63 1.72-2 .47-2.66-1.72zm-4 .92l2.64 1.72-2 .47L7.6 6.19zm-4.08.94l2.63 1.72-2 .47-2.65-1.72zm14.91 13.58H3.55V11h16.9v9.29z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "icon-video_svg__cls-1",
  d: "M10.4 13.17v5l4-2.49z"
})));

export default SvgIconVideo;